import { apiFetch } from "@/lib/api";

export const DEVICE_LOOKUP_KEY = "quality-device-lookup";

export interface DeviceEpisode {
  id: number;
  deviceId: number;
  deviceLabelSerial: string | null;
  finishedSku: string | null;
  firmwareVersion: string | null;
  imei: string | null;
  mcuUuid: string | null;
  pcbaSerial: string | null;
  pcbaBuildOrderSku: string | null;
  boardRevision: string | null;
  clampSerial: string | null;
  batchItemId: number | null;
  stationId: number | null;
  stationName: string | null;
  archivedAt: string | null;
  dateAssembled: string | null;
  rebuild: boolean;
  active: boolean;
}

export interface DeviceLookupResponse {
  deviceId: number;
  activeEpisodeId: number | null;
  episodes: DeviceEpisode[];
  incidents: DeviceIncident[];
}

export interface DeviceIncident {
  id: number;
  serialFciId: number | null;
  issue: string | null;
  issueDate: string | null;
  resolutionDate: string | null;
  repairScrap: string | null;
  type: string | null;
  subtype: string | null;
  open: boolean;
}

export async function fetchDeviceLookup(label: string): Promise<DeviceLookupResponse> {
  const params = new URLSearchParams({ label });
  return apiFetch<DeviceLookupResponse>(`/api/quality/devices/lookup?${params.toString()}`);
}
